type ConvertCurrencyOptions = {
    toUnit?: "minor" | "major"
}

export function convertCurrency(amount: number, options?: ConvertCurrencyOptions) {
    switch (options?.toUnit) {
        case "minor":
            return amount * 100
        case "major":
        default:
            return amount / 100
    }
}
